import { EpisodeContextType } from "@/containers/Episode/context";

export const extractMentionTrackingPayload = (
  mention: Pick<EpisodeContextType, "audio_url" | "share_url">
) => {
  return { url: mention.share_url, source: mention.audio_url };
};
